// src/pages/Callback.tsx
import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

const Callback = () => {
  const { isLoading, isAuthenticated, user, error } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("🔄 Auth0 loading:", isLoading);
    console.log("✅ Auth0 authenticated:", isAuthenticated);
    console.log("👤 Auth0 user:", user);
    console.log("❌ Auth0 error:", error);

    if (!isLoading) {
      if (isAuthenticated) {
        navigate('/');
      } else if (error) {
        console.error("Error en autenticación:", error);
      }
    }
  }, [isLoading, isAuthenticated, user, error, navigate]);

  return (
    <div className="text-center mt-10 text-gray-600">
      Processing login...
    </div>
  );
};

export default Callback;